import React from "react";
import TopHeader from "../../Components/TopHeader";
import Footer from "../../Components/Footer";
import EmailSubscription from "../../Components/EmailSubscription";
import { Link } from "react-router-dom";
const Press = () =>{
    return (
        <>
        <TopHeader/>
        <div className="main-container no-overflow-x pt-0 -with-cta-banner">
  <div className="w-100 text-center">
    <div className="press-header">
      <div className="content">
        <h1 className="header mb-4">
          <span className="hurr-font-logo">
            CIRCULAR
          </span>
          {' '}in the press
        </h1>
        <p className="description mb-0">
          We’re on a mission to bring fashion full circle and have been lucky enough to receive some media coverage to help us along the way.
        </p>
      </div>
    </div>
    <div className="press-section mt-0 mt-md-4 mb-0 mb-lg-4">
      <div className="content">
        <div className="row no-gutters">
          <div className="col-lg-6 align-self-center">
            <div className="press-info mb-5 mb-lg-0">
              {' '}
              <img
                alt="Forbes logo"
                className="logo"
                height="26"
                src="https://res.cloudinary.com/dcaptnlz3/image/asset/forbes-9474c6544da7323fd3b2b915b4fde999.svg"
                width="100.23"
              />
              <div className="press-forbes">
                <h2 className="title mb-4">
                  “This Startup wants to be the airbnb of fashion"
                </h2>
                {' '}
                <Link
                  className="default-link cta"
                  to="#"
                  target="_blank"
                >
                  Read More
                </Link>
                {' '}
              </div>
            </div>
          </div>
          <div className="col-lg-6 align-self-center">
            <div className="press-info mt-5 pt-0 pt-md-5 mt-lg-0 pt-lg-0">
              {' '}
              <img
                alt="Financial Times logo"
                className="logo"
                height="26"
                src="https://res.cloudinary.com/dcaptnlz3/image/asset/financial-times-667875c3a481ccf942ad400193e7e8b7.svg"
                width="321.47"
              />
              <div className="press-financial-times">
                <h2 className="title mb-4">
                  “Why renting your wardrobe makes fashion sense"
                </h2>
                {' '}
                <Link
                  className="default-link cta"
                  to="#"
                  target="_blank"
                >
                  Read More
                </Link>
                {' '}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="press-section mb-0 mb-lg-4">
      <div className="content">
        <div className="row no-gutters">
          <div className="col-lg-6 align-self-center">
            <div className="press-info mb-5 mb-lg-0">
              {' '}
              <img
                alt="Business of Fashion Logo"
                className="logo"
                height="35"
                src="https://res.cloudinary.com/dcaptnlz3/image/asset/BOF-ac5f9bc66a9c17500d1e1f6a8f23d2d3.svg"
                width="76.25"
              />
              <div className="press-evening-standard">
                <h2 className="title mb-4">
                  “Depop Partners with Rental
                  <br />
                  {' '}Platform{' '}
                  <span className="hurr-font-logo">
                    CIRCULAR
                  </span>
                  ”
                </h2>
                {' '}
                <Link
                  className="default-link cta"
                  to="#"
                  target="_blank"
                >
                  Read More
                </Link>
                {' '}
              </div>
            </div>
          </div>
          <div className="col-lg-6 align-self-center">
            <div className="press-info mt-5 pt-0 pt-md-5 mt-lg-0 pt-lg-0">
              {' '}
              <img
                alt="Who What Wear logo"
                className="logo"
                height="23"
                src="https://res.cloudinary.com/dcaptnlz3/image/asset/who-what-wear-00d377408f9d76311c72fc1b25e809ce.svg"
                width="331.38"
              />
              <div className="press-who-what-wear">
                <h2 className="title mb-4">
                  “Why fashion girls are going to start sharing their clothes in 2019”
                </h2>
                {' '}
                <Link
                  className="default-link cta"
                  to="#"
                  target="_blank"
                >
                  Read More
                </Link>
                {' '}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="press-section">
      <div className="content">
        <div className="row no-gutters">
          <div className="col-lg-6 align-self-center">
            <div className="press-info mb-5 mb-lg-0">
              {' '}
              <img
                alt="Vanity Fair logo"
                className="logo"
                height="32"
                src="https://res.cloudinary.com/dcaptnlz3/image/asset/vanity-fair-fc0329f77b8b44251e37e82e8cfe1691.svg"
                width="162.42"
              />
              <div className="press-vanity-fair">
                <h2 className="title mb-4">
                  “
                  <span className="hurr-font-logo">
                    CIRCULAR
                  </span>
                  {' '}is the airbnb of fashion”
                </h2>
                {' '}
                <Link
                  className="default-link cta"
                  to="#"
                  target="_blank"
                >
                  Read More
                </Link>
                {' '}
              </div>
            </div>
          </div>
          <div className="col-lg-6 align-self-center">
            <div className="press-info mt-5 pt-0 pt-md-5 mt-lg-0 pt-lg-0">
              {' '}
              <img
                alt="Bazaar logo"
                className="logo"
                height="40"
                src="https://res.cloudinary.com/dcaptnlz3/image/asset/bazaar-8e81018534a4772ac09d4307e1f669f5.svg"
                width="164.14"
              />
              <div className="press-bazaar">
                <h2 className="title mb-4">
                  “We trial the future of fashion and embrace the idea of renting our wardrobes.”
                </h2>
                {' '}
                <Link
                  className="default-link cta"
                  to="#"
                  target="_blank"
                >
                  Read More
                </Link>
                {' '}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    {' '}
    <Link
      className="btn btn-primary -dark-red press-cta my-0 my-md-5"
      to="#"
    >
      Media enquiries
    </Link>
    {' '}
  </div>
</div>
        <EmailSubscription/>
        <Footer/>
        </>
    )
}

export default Press;